// extracted by mini-css-extract-plugin
module.exports = {"wiggle":"PushNotificationIcon_wiggle__kPe3e"};